//
// forms/helpers.js = helper functions
//

import find_ancestor from '../helpers/find-ancestor';


// hide_field
// ----------------------------------

function hide_field(el) {
  el = get_field_container(el);
  if (el) {
    el.classList.add('c-form-set--hidden');
  }
}


// remove_field()
// ----------------------------------

function remove_field(el) {
  el = get_field_container(el);
  if (el) {
    el.parentNode.removeChild(el);
  }
}


// get_field_container()
// ----------------------------------
// - find the wrapping div for an element
//   within a field item

function get_field_container(el) {
  if (el && !el.classList.contains('c-form-set')) {
    el = find_ancestor(el, 'c-form-set');
  }
  return el;
}


// get_redirect() - get the redirect for a form
// ----------------------------------

function get_redirect(form, response_obj, form_data) {
  if (response_obj.followup_actions.prevent_all) {
    return;
  }

  let redirect = null;
  const form_redir = form.getAttribute('data-redirect');
  const mkto_redir = form.getAttribute('data-mkto-redirect-obj');

  // Priority 1: A redirect set on response_obj (by js_callback or a success process)
  if (response_obj.followup_actions.redirect) {
    redirect = response_obj.followup_actions.redirect;
  }

  // Priority 2: Form's custom redirect
  if (redirect === null && form_redir) {
    redirect = atob(form_redir);
  }

  // Priority 3. Mkto conditional redirect (based on a field value)
  //             Note: currently only supports 'is' field comparison - ie:
  //                   "if x field is 'some string', redirect = '...'"
  if (redirect === null && mkto_redir && form_data) {
    const mkto_redirects = JSON.parse(atob(mkto_redir));

    const redirects = mkto_redirects.reduce((carry, item) => {
      if (item.default === true) {
        carry.default = item.followupValue;
      }
      else if (item.subjectField) {
        carry.controller_field      = item.subjectField;
        carry.rules[item.values[0]] = item.followupValue; // { Book a Meeting: 'https://www.bw.com/demo'}
      }
      return carry;
    }, { rules: { } });

    const controller_field_val = form_data[redirects.controller_field];

    redirect = redirects.rules[controller_field_val] || redirects.default;
  }

  return redirect;
}


export {
  hide_field,
  remove_field,
  get_field_container,
  get_redirect,
};

